import React, { useEffect, useState, useContext, useRef, useParams } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import Topbar from './Topbar';
import { UserContext } from './UserContext';
import * as XLSX from 'xlsx';
import DatePicker from "react-datepicker";
import { useReactToPrint } from "react-to-print";
import { saveAs } from "file-saver";
import "react-datepicker/dist/react-datepicker.css";

const PurchaseEnquiry = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
      documentTitle: 'Title',
      contentRef: componentRef,
    });
  function formatIndian(num) {
    return num.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  }
    const navigte = useNavigate();

 const formatDate = (data) => {
    if (!data) {
      return "";
    }

    let date;
    const str = String(data).trim();

    // Case 1: SAP OData format -> /Date(1728000000000)/
    const msMatch = str.match(/\/Date\((\d+)\)\//);
    if (msMatch) {
      const timestamp = parseInt(msMatch[1], 10);
      date = new Date(timestamp);
    }
    // Case 2: Y-m-d, optionally followed by a time/timezone part
    else if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
      const [year, month, day] = str.slice(0, 10).split("-");
      date = new Date(Number(year), Number(month) - 1, Number(day));
    }
    // Case 3: Fallback
    else {
      date = new Date(str);
    }

    if (isNaN(date.getTime())) {
      return "";
    }

    let day = String(date.getDate()).padStart(2, "0");
    let month = String(date.getMonth() + 1).padStart(2, "0");
    let year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const { userData } = useContext(UserContext);
  const [prData, setPrData] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('authToken');
  const userId = localStorage.getItem('userId');
  const [searchText, setSearchText] = useState('');
  const [filtered, setFiltered] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedFromDate, setSelectedFromDate] = useState(new Date());
  const [selectedToDate, setSelectedToDate] = useState(new Date());
  const [pr, setPr] = useState();
    const [commonDetails, setCommonDetails] = useState([]);
    const [data, setData] = useState([]);
    let [estimatedCost, setEstimatedCost] = useState(null);
    const [creationUserName, setCreationUserName] = useState();
    const [headerNote, setHeaderNote] = useState();

  // Inside the component, after state declarations
  const exportToExcel = () => {
    // Get table element
    const table = document.getElementById("myTable");
    const wb = XLSX.utils.table_to_book(table, { sheet: "Sheet1" });

    // Generate Excel file
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Save
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "table.xlsx");
  };

  const searchRecords = async () => {
    setLoading(true);
    var totalValue;
      setCommonDetails([]); // Clear existing state on reload
      //console.log(baseUrl+`auth/getPRDetails?PurchaseRequisition=${id}&user_id=${userId}`);
    axios.get(baseUrl+`auth/getPRDetails?PurchaseRequisition=${pr}&user_id=${userId}`, config)
      .then(response => {
        //console.log(response.data.data.PR[0]._PurchaseRequisitionItem.headers.YY1_CreationUserName_PRI); return false;
        const commonItems = response.data.data.header;
        //console.log(commonItems); return false;
        setCommonDetails(commonItems);
        const data = response.data.data._PurchaseRequisitionItem;
        const arrayData = Object.values(data).filter(item => typeof item === 'object' && !Array.isArray(item));
        setData(arrayData);
        const totalValue = data.reduce((acc, item) => acc + item.ItemNetAmount, 0);
        const formattedValue = totalValue.toLocaleString('en-IN');
        setEstimatedCost(formattedValue);
        setLoading(false);
        //console.log(response.data.data._PurchaseRequisitionItem);
        setCreationUserName(response.data.data._PurchaseRequisitionItem[0].YY1_CreationUserName_PRI);
        //console.log(response.data.data._PurchaseRequisitionItem.YY1_CreationUserName_PRI); return false;
        setHeaderNote(response.data.data.PR[0].headers.PurReqnHeaderNote);
      })
      .catch(error => {
        console.log(error.reponse);
        setLoading(false);
      });
  };
  const navigate = useNavigate();

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(page);
  };

  useEffect(() => {
    
  }, []);

  return (
    <>
      <Topbar />
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="row page-titles">
            <div className="col-md-5 align-self-center">
              <h4 className="text-themecolor">Purchase Enquiry</h4>
            </div>
            <div className="col-md-7 align-self-center text-end">
              <div className="d-flex justify-content-end align-items-center">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                  <li className="breadcrumb-item active">Purchase Enquiry</li>
                </ol>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                   <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
                    <input className="form-control" style={{width:"50%", marginRight: "10px", marginLeft: "18px"}} onChange={(e) => setPr(e.target.value)} type="PR Number" required="" placeholder="PR Number" />
                    <button
                      onClick={searchRecords}
                      style={{
                        width: "10%",
                        padding: '7px 15px',
                        background: '#28a745',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        marginRight: '24px'
                      }}
                    >
                      Search
                    </button>

                    {/* <button
                      onClick={exportToExcel}
                      style={{
                        padding: '10px 15px',
                        background: '#28a745',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                      }}
                    >
                      Export to Excel
                    </button> */}
                  </div>
                  { commonDetails.PurReqnReleaseStatus && commonDetails.PurReqnReleaseStatus!="05" ? <span style={{color:"red", fontSize: "18px", marginRight: "23px"}}>Sorry, The PR details you are searching for are not approved yet!!</span> :
                  <>
                  <div ref={componentRef} id="myTable" style={{margin: "10px 20px 10px 20px", border: "2px solid #000", padding: "2px"}}>
                                      <table style={{ width: "100%", textAlign: "center", fontSize: "12px" }}>
                                        <tbody>
                                        <tr>
                                          <td style={{ border: "2px solid black", justifyContent: 'center' }} rowSpan={3}>
                                            <img
                                              src="data:image/jpeg;base64,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"
                                              height='50'></img></td>
                                          <td style={{ border: "2px solid black", fontWeight: "bold" }}>KALINGA COMMERCIAL CORPORATION LIMITED </td>
                                          <td style={{ border: "2px solid black", textAlign:'left', fontWeight:"bold" }}><input type="text" name="ref" id="ref" defaultValue={commonDetails.YY1_REF_PRI ? commonDetails.YY1_REF_PRI : ""} style={{border: "none"}}></input></td>
                                        </tr>
                                        <tr>
                                          <td style={{ border: "2px solid black", fontWeight:"bold" }}>PROCUREMENT DEPARTMENT</td>
                                          <td style={{ border: "2px solid black", textAlign:'left', fontWeight:"bold" }}>REV : <input type="text" name="rev" id="rev" defaultValue={commonDetails.YY1_REV_PRI} style={{border: "none"}}></input></td>
                                        </tr>
                                        <tr>
                                          <td style={{ border: "2px solid black", fontWeight:"bold" }}>Request for Quotation (RFQ): </td>
                                          <td style={{ border: "2px solid black", textAlign:'left', fontWeight:"bold" }}>WEF : <input type="text" name="wef" id="wef" defaultValue="22/04/2026" style={{border: "none"}}></input></td>
                                        </tr>
                                        </tbody>
                                      </table>
                                      <table
      style={{
        borderCollapse: "collapse",
        width: "100%",
        border: "1px solid black",
        textAlign: "left"
      }}
    >
      <tbody>
        <tr>
          <td
            colSpan="3"
            style={{ border: "1px solid black", fontWeight: "bold", padding: "5px" }}
          >
            <b>No:</b>{" "}
            <span style={{marginRight: '10px'}}>{commonDetails.PurchaseRequisition}</span>
            <b>Date:</b>{" "}
            <span>{commonDetails.PurchaseRequisitionReleaseDate}</span>
          </td>
          {/* <td style={{ border: "1px solid black", padding: "5px" }}>
            
          </td> */}
        </tr>

        <tr>
          {/* <td
            colSpan="3"
            rowSpan="3"
            style={{ border: "1px solid black", padding: "30px" }}
          ></td> */}
          <td style={{ border: "1px solid black", padding: "5px" }}>
            <b>Doc. Type: </b>{" "}
            <span>{commonDetails.YY1_DocumentTypeDesc_PRI}</span>
          </td>
        </tr>

        {/* <tr>
          <td style={{ border: "1px solid black", padding: "5px" }}>
            <b>DUE ON OR BEFORE:</b>
            <br />
            <span style={{ fontSize: "12px" }}>
              (Your quotation will be considered only if received on or before this date)
            </span>
          </td>
        </tr> */}

        <tr>
          <td style={{ border: "1px solid black", padding: "5px" }}>
            <b>Plant</b>{" "}
            <span>{commonDetails.YY1_PlantDescription_PRI}</span>
          </td>
        </tr>

        <tr>
          <td colSpan="4" style={{ border: "1px solid black", padding: "5px" }}>
            Dear Sir, <br />
            You are requested to submit your best quotation at the{" "}
            <span>earliest</span> as per the following
            details
          </td>
        </tr>
      </tbody>
    </table>

                                      <table style={{ width: "100%", textAlign: "center", fontSize: "12px" }}>
                                        <tbody>
                                        <tr>
                                        <td style={{ border: "2px solid black", fontWeight:"bold" }} colSpan={2}>Equipment Details </td>
                                        <td style={{ border: "2px solid black", fontWeight:"bold" }} colSpan={2}> Engine Details</td>
                                        <td style={{ border: "2px solid black", fontWeight:"bold" }} colSpan={2}> Component Details </td
                                        >
                                        <td style={{ border: "2px solid black", fontWeight:"bold" }} colSpan={2}>Additional Details</td
                                        ></tr>
                                                  <tr>
                                                    <td style={{ border: "2px solid black", fontWeight:"bold", width: "12%" }}>Make:-</td>
                                                    <td style={{ border: "2px solid black", width: "12%" }}>{commonDetails.YY1_EquipmentMake_PRI || '-'}</td>
                                                    <td style={{ border: "2px solid black", width: "12%", fontWeight:"bold"}}>Make:-</td>
                                                    <td style={{ border: "2px solid black", width: "12%" }}>{commonDetails.YY1_EngineMake_PRI || '-'}</td>
                                                    <td style={{ border: "2px solid black", width: "12%", fontWeight:"bold" }}>Make:-</td>
                                                    <td style={{ border: "2px solid black", width: "12%" }}>{commonDetails.YY1_ComponentMake_PRI || '-'}</td>
                                                    <td style={{ border: "2px solid black", width: "12%", fontWeight:"bold" }}>Criticality:-</td>
                                                    <td style={{ border: "2px solid black", width: "12%" }}>{commonDetails.YY1_Criticality_PRI || '-'}</td>
                                                  </tr>
                                                  <tr>
                                                    <td style={{ border: "2px solid black", fontWeight:"bold" }}>Model:-</td>
                                                    <td style={{ border: "2px solid black" }}>{commonDetails.YY1_EquipModel_PRI || '-'}</td>
                                                    <td style={{ border: "2px solid black", fontWeight:"bold" }}>Model:-</td>
                                                    <td style={{ border: "2px solid black" }}>{commonDetails.YY1_EngineModel_PRI || '-'}</td>
                                                    <td style={{ border: "2px solid black", fontWeight:"bold" }}>Model:-</td>
                                                    <td style={{ border: "2px solid black" }}>{commonDetails.YY1_ComponentModel_PRI || '-'}</td>
                                                    <td style={{ border: "2px solid black", fontWeight:"bold" }}>HMR / KMR:-</td>
                                                    <td style={{ border: "2px solid black" }}>{commonDetails.YY1_Equipment_HMR_PRI || '-'}</td>
                                                  </tr>
                                                  <tr>
                                                    <td style={{ border: "2px solid black", fontWeight:"bold" }}>Sl. No:-</td>
                                                    <td style={{ border: "2px solid black" }}>{commonDetails.YY1_EquipSINO_PRI || '-'}</td>
                                                    <td style={{ border: "2px solid black", fontWeight:"bold" }}>Sl. No:-</td>
                                                    <td style={{ border: "2px solid black" }}>{commonDetails.YY1_EngineSINO_PRI || '-'}</td>
                                                    <td style={{ border: "2px solid black", fontWeight:"bold" }}>Sl. No:-</td>
                                                    <td style={{ border: "2px solid black" }}>{commonDetails.YY1_ComponentSINO_PRI || '-'}</td>
                                                    <td style={{ border: "2px solid black", fontWeight:"bold" }}>Warranty Status:-</td>
                                                   <td style={{ border: "2px solid black", fontWeight:"bold" }}>{commonDetails.YY1_WarrantyStatus_PRI || '-'}</td>
                                                  </tr>
                                                  <tr>
                                                    <td colSpan={6} style={{ borderBottom: "2px solid black" }}></td>
                                                  </tr>
                                      </tbody>
                                      </table>
                  
                                      <table style={{ width: "100%", textAlign: "center", fontSize: "12px" }}>
                                        <tbody>
                                        <tr>
                                          <td style={{ border: "2px solid black", fontWeight: "bold" }} >Sl. No.</td>
                                          <td style={{ border: "2px solid black", fontWeight: "bold" }} > MATERIAL CODE </td>
                                          <td style={{ border: "2px solid black", fontWeight: "bold" }} > DESCRIPTION </td>
                                          <td style={{ border: "2px solid black", fontWeight: "bold" }} > PART NO. </td>
                                          <td style={{ border: "2px solid black", fontWeight: "bold" }} > TECHNICAL DETAILS </td>
                                          <td style={{ border: "2px solid black", fontWeight: "bold" }} > QUANTITY </td>
                                          <td style={{ border: "2px solid black", fontWeight: "bold" }} > UOM </td>
                                          <td style={{ border: "2px solid black", fontWeight: "bold" }} > DELIVERY DATE </td>
                                        </tr>
                                        {data.filter((item) => !item.IsDeleted).map((item, index) => {
                    // Add your condition here. Adjust fields as needed.
                    const hasContent = item.YY1_ItemText_PRI || item.Material || item.YY1_CostCenter_PRI || item.ItemNetAmount || item.RequestedQuantity;
                  
                    if (!hasContent) return null;
                  
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td style={{ border: "2px solid black" }}>{index + 1}</td>
                          <td style={{ border: "2px solid black" }}>{item.Material}</td>
                          <td style={{ border: "2px solid black", textAlign: "left" }}>
                            {item.AccountAssignmentCategory === "K"
                              ? item.YY1_CostCenter_PRI
                              : item.Material + " " + item.PurchaseRequisitionItemText}
                          </td>
                          <td style={{ border: "2px solid black" }}>{item.YY1_OldMatNumber_PRI}</td>
                          <td style={{ border: "2px solid black" }}>{item.YY1_ItemText_PRI}</td>
                          <td style={{ border: "2px solid black" }}>{item.RequestedQuantity}</td>
                          <td style={{ border: "2px solid black" }}>{item.BaseUnit}</td>
                          <td style={{ border: "2px solid black" }}>{formatDate(item.DeliveryDate)}</td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                                          <tr>
                          <td colSpan={1} style={{ border: "2px solid black", fontWeight: "bold"  }}>
                            Remarks:
                          </td>
                          <td colSpan={7} style={{ border: "2px solid black", textAlign: "left" }}>{commonDetails.PurReqnHeaderNote}</td>

                        </tr>

                                          
                                      </tbody>
                                      </table>
                                      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
  <tbody>
    <tr>
      <th style={{ width: "50%", textAlign: "left", border: "1px solid black", padding: "6px", fontWeight: "500", verticalAlign: "top" }}>
        Kindly include the following details in your offer:
      </th>
      <th style={{ textAlign: "left", border: "1px solid black", padding: "0", fontWeight: "500", verticalAlign: "top" }}>
        <div style={{ borderBottom: "1px solid black", padding: "6px" }}>DRAWINGS/SPECIMENS/NORMS/ETC.</div>
        <div style={{ borderBottom: "1px solid black", padding: "6px" }}>PLEASE RETURN THEM ALONG WITH YOUR QUOTATION.</div>
      </th>
    </tr>
    <tr>
      <td style={{ border: "1px solid black", padding: "6px" }}><strong>1. Validity:</strong></td>
      <td rowSpan={7} style={{ border: "1px solid black", padding: "6px", verticalAlign: "top" }}><strong>NOTE:</strong></td>
    </tr>
    <tr>
      <td style={{ border: "1px solid black", padding: "6px" }}><strong>2. Basic Rate per unit:</strong></td>
    </tr>
    <tr>
      <td style={{ border: "1px solid black", padding: "6px" }}><strong>3. For job work:</strong></td>
    </tr>
    <tr>
      <td style={{ border: "1px solid black", padding: "6px" }}><strong>4. Applicable taxes &amp; duties: </strong></td>
    </tr>
    <tr>
      <td style={{ border: "1px solid black", padding: "6px" }}><strong>5. Delivery schedule: </strong></td>
    </tr>
    <tr>
      <td style={{ border: "1px solid black", padding: "6px" }}><strong>6. Warrantee / Guarantee :</strong></td>
    </tr>
    <tr>
      <td style={{ border: "1px solid black", padding: "6px" }}><strong>7. Payment Terms:</strong></td>
    </tr>
        <tr>
      <td style={{ border: "1px solid black", padding: "6px" }}><strong>8. Price Base:</strong> Ex-Works / FOR</td>
    </tr>
            <tr>
      <td style={{ border: "1px solid black", padding: "6px" }}><strong>9. Test Certificate (If Applicable) :</strong> </td>
    </tr>

    

  </tbody>
</table>
                 {/*  <table style={{ width: "100%", textAlign: "center", fontSize: "12px" }}>
                    <tbody>
                      <tr><td style={{border:"2px solid black", fontWeight: "bold"}}>NOTE : -  IN CASE OF CAPITAL ITEMS DETAILS OF SANCTION BY CMD MAY FURNISHED </td></tr>
                    </tbody>
                  </table> */}
                                    </div>
                                      <button onClick={() => handlePrint()} style={{marginTop:"10px", marginLeft: "45%"}}>Print this out!</button>
                                      </>  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PurchaseEnquiry;
